import { useQuery } from 'react-query';
import { generic, transaction } from 'apis';
import { ProjectTables } from 'enums';
import { formatFileGroups } from 'utils/formatFileGroups';
import { useParams } from 'react-router';
import decodeToken from 'utils/decode-token';

export const useTransactionSubmittionData = () => {
    const { token } = useParams();

    const payload = decodeToken(token);

    const transactionId = payload?.transactionId;

    if (!transactionId) {
        throw new Error('Invalid Transaction');
    }

    const transactionDetailsQuery = useQuery(['transactionDetails', transactionId], async () => {
        const details = await transaction.gettransaction(
            { transactionId },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return details;
    });

    const filesQuery = useQuery(
        ['transactionFiles', transactionId],
        async () => {
            const requestData = {
                DataValue: null,
                DataKey: 'Transactions',
                RecordGuid: transactionId === 'new' ? null : transactionId,
                ProjectTableId: ProjectTables.TransHeader,
                UserId: null,
                token
            };
            const files = await generic.getFiles(requestData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const formatted = formatFileGroups(files);
            return formatted;
        },
        {
            retry: 1
        }
    );

    return {
        transactionDetailsQuery,
        filesQuery,
        token
    };
};
